import AOS from 'aos';
import Glide from '@glidejs/glide'

let aos = AOS.init({
  once: true,
  duration: 1200,
});

// Nav mobile
const body = document.body;
const navicon = document.getElementById('navicon');
const nav = document.querySelector('nav.menu-wrapper');
navicon.onclick = function () {
  if (navicon.classList.contains('active')) {
    navicon.classList.replace('active', 'passive');
    body.classList.toggle('nav-open');
    nav.classList.toggle('active');
  } else {
    navicon.classList.replace('passive', 'active');
    body.classList.toggle('nav-open');
    nav.classList.toggle('active');
  }
}

var hrefs = document.querySelectorAll('a[href^="#"]')
for (var i = 0; i < hrefs.length; i++) {
  hrefs[i].addEventListener('click', function (e) {
    e.preventDefault();
    const target = this.getAttribute('href');

    if (target !== '#') {
      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    }
  });
}

// scroll top menu
var scrollObject = {};
window.onscroll = getScrollPosition;
const main = document.getElementById('main');

function getScrollPosition() {
  scrollObject = {
    x: window.pageXOffset,
    y: window.pageYOffset
  }
  if (scrollObject.y > 30) {
    main.classList.add('is-active');
  } else {
    main.classList.remove('is-active');
  }
}


// Class "collapsible" pour avoir un systeme d'accordeon javascript
var coll = document.querySelectorAll(".collapsible");
var i;


var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");

    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}


var carousel = document.getElementById('main-carousel-retailer');
if (carousel) {
  var glide = new Glide('#main-carousel-retailer', {
    type: 'slider',
    perView: 8,
    rewind: false,
    keyboard: true,
    animationDuration: 1200,
    breakpoints: {
      1600: {
        perView: 6,
      },
      800: {
        perView: 4
      },
      600: {
        perView: 3
      },
      480: {
        perView: 2,
      }
    }
  });
  glide.mount()
}
//
//loadComponents(components);
